/** Static catalog and reviewed product guides. */
export { FLAI_REQUEST_CONFIG, FLAI_DAILY_LIMIT_MESSAGE } from './config/flai-request.config';
export { APPLICATION_PAGES } from './catalog/pages';
export { APPLICATION_INVENTORY } from './catalog/inventory';
export type { IInventoryPage } from './catalog/inventory-page.interface';
export { APPLICATION_REDIRECTS } from './catalog/redirects';
export { RESEARCH_GUIDES } from './guides/research';
export { RESEARCH_ACCESS_GUIDANCE } from './guides/research-access';
export type { IPageGuide } from './guides/page-guide.interface';

/** Select relevant knowledge for a route and question. */
export { getApplicationKnowledge } from './lookup/get-knowledge';
export type { IKnowledgeResult, TypeKnowledgeGuide } from './lookup/knowledge-result.interface';
export { normalizeRoute } from './lookup/route';
